module.exports = __webpack_public_path__ + "img/t3.b180ddf7.jpg";